module.exports = __webpack_public_path__ + "img/LLPRO_CEFR_banner_woman.10adf3fe.png";